import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { chevronDown, chevronUp, personCircleOutline } from 'ionicons/icons';
import { IonIcon } from '@ionic/angular/standalone';
import { addIcons } from 'ionicons';

@Component({
  selector: 'app-data-collected',
  templateUrl: './data-collected.component.html',
  styleUrls: [
    '../../../assets/bootstrap/bootstrap.css',
    './data-collected.component.scss',
  ],
  standalone: true,
  imports: [CommonModule, FormsModule, IonIcon],
})
export class DataCollectedComponent implements OnInit {
  dataCollected: any = {};
  isOver: any = {};

  constructor() {
    addIcons({ personCircleOutline, chevronDown, chevronUp });
  }

  ngOnInit(): void {}
}
